import { lazy, Suspense, useState } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router'

import { TabBar } from '~/shared/ui'

import { renderTabIcon, TABS } from './config'

/** Почему счётчик приезжает отдельным чанком — см. комментарий в UnreadProbe. */
const UnreadProbe = lazy(() => import('./UnreadProbe').then((m) => ({ default: m.UnreadProbe })))

/**
 * Каркас с нижним меню-островом (спека 03 §1). Активная вкладка — по pathname,
 * бейдж непрочитанного — на вкладке "Узы".
 */
export function TabsLayout() {
  const location = useLocation()
  const navigate = useNavigate()

  const activeTab = TABS.find((tab) => tab.path === location.pathname) ?? TABS[0]!

  // Точка непрочитанного на вкладке «Узы» — спека 03 §1. Число приходит снизу, из
  // ленивого UnreadProbe: сам хук утащил бы в бандл входа три слайса разом.
  const [unreadCount, setUnreadCount] = useState(0)
  const hasUnreadInLinks = unreadCount > 0

  return (
    <>
      <Outlet />
      <Suspense fallback={null}>
        <UnreadProbe onCount={setUnreadCount} />
      </Suspense>
      <TabBar
        items={TABS.map((tab) => ({
          key: tab.key,
          label: tab.label,
          icon: renderTabIcon(tab.icon),
          badge: tab.key === 'links' && hasUnreadInLinks,
        }))}
        activeKey={activeTab.key}
        onSelect={(key: string) => {
          const tab = TABS.find((item) => item.key === key)
          if (tab) {
            navigate(tab.path)
          }
        }}
      />
    </>
  )
}
